import React from 'react'
import { Number, NumberProps } from './Number'

export const Currency: React.FC<NumberProps> = ({ locale, style = 'currency', currency = 'USD', value}) => {
  return <Number locale={locale} style={style} currency={currency} value={value} />
}

export default Currency